"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModal = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _Button = require("../../elements/button/Button");
var _iconCloseGray = _interopRequireDefault(require("../../icons/icon-close-gray.svg"));
var _mediaQuery = _interopRequireDefault(require("../../styles/media-query"));
const DarkOverlay = _styled.default.div(_ref => {
  let {
    theme
  } = _ref;
  return {
    background: theme.colors.black,
    height: '100vh',
    opacity: '.8',
    position: 'absolute',
    top: '0',
    width: '101vw',
    zIndex: '5'
  };
});
const ModalWrapper = _styled.default.dialog({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  justifyContent: 'center',
  left: '0',
  position: 'absolute',
  top: '0',
  width: '100vw'
});
const StyledModal = _styled.default.div(_ref2 => {
  let {
    theme
  } = _ref2;
  return (0, _mediaQuery.default)({
    background: theme.colors.white,
    maxHeight: '100vh',
    maxWidth: '100vw',
    overflowY: 'auto',
    padding: '10px',
    width: ['95vw', null, '80%', '80%'],
    zIndex: '10'
  });
});
const TitleBar = _styled.default.div({
  display: 'flex',
  flexDirection: 'row-reverse'
});
const StyledCloseIcon = _styled.default.img({
  '&:hover': {
    cursor: 'pointer'
  }
});
const ModalBody = _styled.default.div({
  alignContent: 'center',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
});

/**
 * A modal component that should has configurable children.
 * DO NOT RENDER DIRECTLY. Use the custom hook below to render. Follow the example in
 * the modal story.
 * REQUIRES A #modal ELEMENT.
 */
const Modal = _ref3 => {
  let {
    children,
    className,
    closeButtonText = 'Close',
    closeModal
  } = _ref3;
  const modalRoot = document.getElementById('modal');
  (0, _react.useEffect)(() => {
    const escapeKeyListener = event => {
      if (event.key === 'Escape') {
        closeModal();
      }
    };
    document.addEventListener('keydown', escapeKeyListener);
    return () => document.removeEventListener('keydown', escapeKeyListener);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return modalRoot ? /*#__PURE__*/_reactDom.default.createPortal(/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(DarkOverlay, {
    onClick: () => closeModal()
  }), /*#__PURE__*/_react.default.createElement(ModalWrapper, {
    id: "modal-wrapper"
  }, /*#__PURE__*/_react.default.createElement(StyledModal, {
    className: className,
    id: "styled-modal"
  }, /*#__PURE__*/_react.default.createElement(TitleBar, null, /*#__PURE__*/_react.default.createElement(StyledCloseIcon, {
    alt: "close-icon",
    src: _iconCloseGray.default,
    onClick: () => closeModal()
  })), /*#__PURE__*/_react.default.createElement(ModalBody, null, children, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    color: "primary",
    id: "close-modal",
    name: "close-modal",
    onClick: () => closeModal()
  }, closeButtonText))))), modalRoot) : null;
};
var _default = exports.default = Modal;
/**
 * Custom react hook to handle showing/hiding the modal.
 */
const useModal = onClose => {
  const [visible, setVisible] = (0, _react.useState)(false);
  const closeModal = () => {
    setVisible(false);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  const openModal = () => setVisible(true);
  const RenderModal = _ref4 => {
    let {
      children,
      className,
      closeButtonText
    } = _ref4;
    return visible && /*#__PURE__*/_react.default.createElement(Modal, {
      className: className,
      closeButtonText: closeButtonText,
      closeModal: closeModal
    }, children);
  };
  return {
    closeModal,
    openModal,
    RenderModal
  };
};
exports.useModal = useModal;